<div class="dados-cockpit" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
    <div class="titulo-pagina">
        <div>
            <div class="col">
                <label class="elem1">Vendido no Mês</label>
                <small class="cifrao">R$</small> <b class="elem2">{{ total_current_month | currency: ' ':'symbol':'1.0-0' }}</b>
            </div>
            <div class="col bordalinha">
                <label class="elem1">Últimos 30 dias</label>
                <small class="cifrao">R$</small> <b class="elem2">{{ total_last_30_days | currency: ' ':'symbol':'1.0-0' }}</b>
            </div>
            <div class="offset-right-md-8"></div>
            <div class="col text-center">
                <button class="btn btn-primary btn-sm" (click)="carregarTela(0)"><i class="fa fa-refresh"></i> {{'seller.cockpit.atualizar' | translate}}</button>
            </div>
        </div>
    </div>
    @if (cockpit) {
        <ng-scrollbar>
            <div class="corpo">
                <div class="card card-default grafico">
                    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions" [legend]="barChartLegend" [type]="barChartType"></canvas>
                    <div class="info">
                        <span><i class="fa fa-info-circle"></i>{{'seller.cockpit.market-share' | translate}}</span>
                    </div>
                </div>
                <div class="break"></div>
                <div class="card card-default tabela">
                    <section class="meses">
                        <header>
                            @if (!is_resposta_automatica) {
                                <div class="col"></div>
                            }
                            <div class="col" style="min-width: 120px;"><span>{{'seller.cockpit.tabela.cabecalho.mes' | translate}}</span></div>
                            <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.suas-vendas' | translate}}</span></div>
                            <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.market-share' | translate}}</span></div>
                            <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.total-vendas.titulo' | translate}}</span> <i class="fa fa-info-circle" tooltip="{{'seller.cockpit.tabela.cabecalho.total-vendas.tooltip' | translate}}"></i></div>
                            <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.total-oportunidades' | translate}}</span></div>
                            @if (!is_resposta_automatica) {
                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.respondidas' | translate}}</span></div>
                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.aproveitamento' | translate}}</span></div>
                            }
                        </header>
                        @for (item of cockpit; track item) {
                            <div class="linha">
                                @if (!is_resposta_automatica) {
                                    <div class="col">
                                        <span class="fa-stack" (click)="carregarDetalheMes(item, 0)">
                                            <i class="fa fa-stack-1x" [ngClass]="item.visivel ? 'fa-minus' : 'fa-plus'"></i>
                                            <i class="fa fa-circle-thin fa-stack-2x"></i>
                                        </span>
                                    </div>
                                }
                                <div class="col" style="min-width: 120px;">{{ item.mes }}</div>
                                <div class="col">{{ item.vendas | currency:' ':'symbol':'1.0-0' }}</div>
                                <div class="col">{{ item.marketshare | number }}%</div>
                                <div class="col">{{ item.total | currency:' ':'symbol':'1.0-0' }}</div>
                                <div class="col">{{ item.oportunidades }}</div>
                                @if (!is_resposta_automatica) {
                                    <div class="col">{{ item.respondidas }}</div>
                                    <div class="col">{{ item.aproveitamento | number }}%</div>
                                }
                                @if (item.visivel) {
                                    <div class="break"></div>
                                    <div class="col detalhes">
                                        <section>
                                            <header>
                                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.detalhe.vendedor' | translate}}</span></div>
                                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.detalhe.oportunidades' | translate}}</span></div>
                                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.detalhe.respondidas.titulo' | translate}}</span> <i class="fa fa-info-circle" tooltip="{{'seller.cockpit.tabela.cabecalho.detalhe.respondidas.tooltip' | translate}}"></i></div>
                                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.detalhe.valor-vendido' | translate}}</span></div>
                                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.detalhe.perdidas.titulo' | translate}}</span> <i class="fa fa-info-circle" tooltip="{{'seller.cockpit.tabela.cabecalho.detalhe.perdidas.tooltip' | translate}}"></i></div>
                                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.detalhe.valor-perdido.titulo' | translate}}</span> <i class="fa fa-info-circle" tooltip="{{'seller.cockpit.tabela.cabecalho.detalhe.valor-perdido.tooltip' | translate}}"></i></div>
                                                <div class="col"><span>{{'seller.cockpit.tabela.cabecalho.detalhe.recusadas' | translate}}</span></div>
                                            </header>
                                            @for (detalhe of item.detalhes; track detalhe) {
                                                <div class="linha">
                                                    <div class="col">{{ detalhe.nome_vendedor }}</div>
                                                    <div class="col">{{ detalhe.oportunidades }}</div>
                                                    <div class="col">{{ detalhe.respostas_sim }} ({{ detalhe.pc_participou }}%)</div>
                                                    <div class="col">{{ detalhe.valor_vendido | currency:'R$' }}</div>
                                                    <div class="col">{{ detalhe.sem_resposta }} ({{ detalhe.pc_sem_resposta }}%)</div>
                                                    <div class="col">{{ detalhe.valor_perdido | currency:'R$' }}</div>
                                                    <div class="col">{{ detalhe.respostas_nao }}</div>
                                                </div>
                                            }
                                        </section>
                                    </div>
                                }
                            </div>
                        }
                    </section>
                    <ngx-loading [show]="loading" [template]="template"></ngx-loading>
                </div>
            </div>
        </ng-scrollbar>
    }
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
<ng-template #template></ng-template>
